import { Component, ViewChild } from '@angular/core';
import { InquiriesComponent } from './inquiries/inquiries.component';
import { ChatPanelTypes, ChatsComponent } from './chats/chats.component';
import { SharedModule } from '@/app/shared/shared.module';
import { InquiryKeys } from '@/app/shared/consts/comms-consts';

@Component({
  selector: 'app-support',
  imports: [InquiriesComponent, ChatsComponent, SharedModule],
  templateUrl: './support.component.html',
  styleUrl: './support.component.less',
})
export class SupportComponent {
  @ViewChild('inquiries') inquiriesComponent!: InquiriesComponent;

  selectedInquiryId: string = '';
  currentInquiryKey: InquiryKeys = InquiryKeys.TechnicalSupport;

  forcePanelType: ChatPanelTypes = ChatPanelTypes.Welcome;

  onChatCreated(inquiryId: string) {
    this.selectedInquiryId = inquiryId;
    this.forcePanelType = ChatPanelTypes.Chat;

    // Refresh inquiries list to show the new inquiry
    if (this.inquiriesComponent) {
      this.inquiriesComponent.loadInquiries();
    }
  }

  onTabChanged(tab: InquiryKeys) {
    if (tab !== this.currentInquiryKey) {
      this.selectedInquiryId = '';
      this.currentInquiryKey = tab;
      this.forcePanelType = ChatPanelTypes.Welcome;
    }
  }

  onChatSelected(inquiryId: string | undefined) {
    if (inquiryId !== undefined) {
      this.selectedInquiryId = inquiryId;
      this.forcePanelType = ChatPanelTypes.Chat;
    } else {
      this.selectedInquiryId = '';
      this.forcePanelType = ChatPanelTypes.Welcome;
    }
  }

  onNewChatSelected(newChat: boolean) {
    if (newChat) {
      this.selectedInquiryId = '';
      this.forcePanelType = ChatPanelTypes.CreateTechnicalSupportInquiry;
    }
  }
}
